import { loggingInterceptorProvider } from "./logging.interceptor";
import { httpErrorInterceptorProvider } from "./http-error.interceptor";
import { pendingRequestsInterceptorProvider } from "./pending-http-requests.interceptor";

export const httpInterceptorProviders = [
  ...loggingInterceptorProvider,
  ...pendingRequestsInterceptorProvider,
  ...httpErrorInterceptorProvider,
];
